module.exports = __webpack_public_path__ + "static/media/290314.9d837d0e.png";